module.exports = __webpack_public_path__ + "static/img/ban_1.9047674a.png";